import { Button, Modal } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ErrorMessage from "../Messages/ErrorMessage";

export default function ErrorModal({ error }) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(true);
	const onClose = () => setOpen(false);
	return (
		<Modal size="tiny" open={open} onClose={onClose}>
			<Modal.Content>
				<ErrorMessage error={error} onReportIssue={onClose} />
			</Modal.Content>

			<Modal.Actions>
				<Button content={t("close", "Close")} onClick={onClose} />
			</Modal.Actions>
		</Modal>
	);
}
